module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "charset": "utf-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "styles/custom.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Weapons of Our Warfare")]), _vm._v(" "), _c('div', {
    staticClass: "dedication"
  }, [_c('h1', {
    staticClass: "ct"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_iii",
      "title": "iii"
    }
  }, [_vm._v(" DEDICATION")])]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_c('i', [_vm._v("My first book")]), _vm._v(", This Means War"), _c('i', [_vm._v(", was affectionately dedicated to the love of my life, my beautiful wife, Taisha. But for this work, I felt it necessary to give recognition and absolute dedication to the amazing people of Global Vision Bible Church.")])]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_c('i', [_vm._v("I have never known a faith fellowship that was so eager to learn the truth of God’s Word. I feel more than privileged every day that I wake up to serve and shepherd the most amazing church on the planet. I am humbled and overwhelmed to be a part of this unbelievable and unexplainable move of God in our midst.")])]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_c('i', [_vm._v("The sacrifice of our church family makes my traveling, preaching, and writing possible, and together we’re changing the lives of countless people around the world, all for the sake of the kingdom of God and the proclamation of the gospel of Jesus Christ. Whether you are in-house or online, we are family. We stand together, and we fight together. We weep together, and we laugh together. There is no place on earth I would rather be.")])]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_c('i', [_vm._v("May the face and favor of God rest upon each of you like never before. I love you, Global Vision family. I truly love you.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48141b2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 63
// module chunks = 0